var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Danh sách phiếu thu chưa thanh toán",
        size: "xl",
        "show-confirm": false,
        "cancel-text": "Đóng",
        "cancel-type": "danger",
        "use-panel": false,
        top: "6vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "sk-panel mb-4" }, [
        _c("div", { staticClass: "sk-panel-head" }, [
          _c("div", { staticClass: "sk-panel-icon sk-panel-icon--warning" }, [
            _c("i", { staticClass: "el-icon-user" }),
          ]),
          _c("div", [
            _c("p", { staticClass: "sk-panel-title" }, [
              _vm._v(_vm._s(_vm.studentName || "Đang tải...")),
            ]),
            _c("p", { staticClass: "sk-panel-subtitle" }, [
              _vm._v("\n          Mã học sinh: "),
              _c("strong", [_vm._v(_vm._s(_vm.studentCode || "—"))]),
              _vm._v(" — Lớp/Nhóm/Gói hiện tại\n        "),
            ]),
          ]),
        ]),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          staticClass: "sk-table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "empty-text": "Không có phiếu thu chưa thanh toán",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "STT",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "Tháng-Năm", width: "110", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(row.month) +
                        "/" +
                        _vm._s(row.year) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Đợt", prop: "turn", width: "70", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "Mã phiếu thu",
              prop: "invoiceCode",
              align: "center",
              "min-width": "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("span", [_vm._v(_vm._s(row.invoiceCode || "—"))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Lớp/nhóm",
              prop: "targetName",
              align: "center",
              "min-width": "140",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("span", [_vm._v(_vm._s(row.targetName || "—"))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Thiếu/Thừa phiếu thu trước",
              align: "right",
              "min-width": "130",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "span",
                      {
                        class:
                          row.beforeMoney < 0
                            ? "tdi-money--negative"
                            : "tdi-money--positive",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("formatCurrency")(row.beforeMoney)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Phải thu", align: "right", "min-width": "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "tdi-money tdi-money--bold" }, [
                      _vm._v(_vm._s(_vm._f("formatCurrency")(row.sumMoney))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Đã thu", align: "right", "min-width": "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "tdi-money" }, [
                      _vm._v(
                        _vm._s(_vm._f("formatCurrency")(row.collectedMoney))
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Tiền mặt", align: "right", "min-width": "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "tdi-money" }, [
                      _vm._v(_vm._s(_vm._f("formatCurrency")(row.cashMoney))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Chuyển khoản",
              align: "right",
              "min-width": "130",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "tdi-money" }, [
                      _vm._v(
                        _vm._s(_vm._f("formatCurrency")(row.transferMoney))
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Thiếu/Thừa còn lại",
              align: "right",
              "min-width": "130",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "span",
                      {
                        class:
                          row.afterMoney < 0
                            ? "tdi-money--negative"
                            : "tdi-money--positive",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("formatCurrency")(row.afterMoney)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tác vụ",
              width: "80",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Thanh toán",
                          placement: "top",
                          enterable: false,
                        },
                      },
                      [
                        _vm.checkPermission(["tuition_payment_v4"])
                          ? _c("el-button", {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                icon: "el-icon-wallet",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handlePayment(row)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }